const cards = {
	opacityVariants: {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
		},
	},
};

const modal = {
	overlayVariants: {
		visible: {
			opacity: 1,
		},
		hidden: {
			opacity: 0,
		},
	},
	modalVariants: {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
		},
	}
}

const Animation = {
	cards,
	modal
};

export default Animation;
